import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getVehiclesPublic } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { useFavorites } from '../context/FavoritesContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import VehicleCard from '../components/VehicleCard';

export default function Favorites() {
  const { client } = useAuth();
  const { favoriteIds } = useFavorites();
  const [allVehicles, setAllVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getVehiclesPublic()
      .then(res => setAllVehicles(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const favVehicles = allVehicles.filter(v => favoriteIds.includes(v.id));

  if (!client) {
    return (
      <>
        <Header />
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
          <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center">
            <span className="text-6xl mb-6 block">♥</span>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">Vos favoris</h2>
            <p className="text-gray-600 mb-8">Connectez-vous pour accéder à vos véhicules favoris.</p>
            <Link to="/connexion" state={{ from: '/mes-favoris' }} className="inline-block bg-black text-white px-8 py-3 rounded-lg font-bold hover:bg-gray-800 transition">
              Se connecter
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <div className="mb-10">
            <h1 className="text-3xl font-black text-gray-900 uppercase tracking-wide mb-2">
              Mes <span className="text-yellow-500">Favoris</span>
            </h1>
            <p className="text-gray-500 text-sm">
              {client.civilite} {client.prenom} {client.nom} · {favVehicles.length} véhicule{favVehicles.length > 1 ? 's' : ''} sauvegardé{favVehicles.length > 1 ? 's' : ''}
            </p>
          </div>

          {loading ? (
            <div className="flex justify-center items-center py-32">
              <div className="w-12 h-12 border-4 border-black border-t-transparent rounded-full animate-spin" />
            </div>
          ) : favVehicles.length === 0 ? (
            <div className="text-center py-24">
              <span className="text-8xl mb-6 block text-gray-200">♥</span>
              <h3 className="text-xl font-bold text-gray-500 mb-4">Aucun favori pour l'instant</h3>
              <p className="text-gray-400 mb-8">Cliquez sur le cœur d'un véhicule pour l'ajouter à vos favoris.</p>
              <Link to="/vehicles" className="inline-block bg-black text-white px-8 py-3 rounded-lg font-bold hover:bg-gray-800 transition">
                Voir les véhicules
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {favVehicles.map(vehicle => (
                <VehicleCard key={vehicle.id} vehicle={vehicle} />
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}
